var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostoTrabalho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12.3797 4 12.6935 4.28215 12.7432 4.64823L12.75 4.75V7.25C12.75 7.66421 12.4142 8 12 8C11.6203 8 11.3065 7.71785 11.2568 7.35177L11.25 7.25V4.75C11.25 4.33579 11.5858 4 12 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.25C13.6642 5.25 14 5.58579 14 6C14 6.3797 13.7178 6.69349 13.3518 6.74315L13.25 6.75H10.75C10.3358 6.75 10 6.41421 10 6C10 5.6203 10.2822 5.30651 10.6482 5.25685L10.75 5.25H13.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 6C7.25 3.37665 9.37665 1.25 12 1.25C14.6234 1.25 16.75 3.37665 16.75 6C16.75 8.62335 14.6234 10.75 12 10.75C9.37665 10.75 7.25 8.62335 7.25 6ZM15.25 6C15.25 4.20507 13.7949 2.75 12 2.75C10.2051 2.75 8.75 4.20507 8.75 6C8.75 7.79493 10.2051 9.25 12 9.25C13.7949 9.25 15.25 7.79493 15.25 6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13.25H15C15.9665 13.25 16.75 14.0335 16.75 15V21C16.75 21.4142 16.4142 21.75 16 21.75H8C7.58579 21.75 7.25 21.4142 7.25 21V15C7.25 14.0335 8.0335 13.25 9 13.25ZM15.0573 14.7566L15 14.75H9C8.86193 14.75 8.75 14.8619 8.75 15V20.25H15.25V15C15.25 14.8817 15.1678 14.7825 15.0573 14.7566Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.25C3.3797 7.25 3.69349 7.53215 3.74315 7.89823L3.75 8V21C3.75 21.4142 3.41421 21.75 3 21.75C2.6203 21.75 2.30651 21.4678 2.25685 21.1018L2.25 21V8C2.25 7.58579 2.58579 7.25 3 7.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.25C21.3797 7.25 21.6935 7.53215 21.7432 7.89823L21.75 8V21C21.75 21.4142 21.4142 21.75 21 21.75C20.6203 21.75 20.3065 21.4678 20.2568 21.1018L20.25 21V8C20.25 7.58579 20.5858 7.25 21 7.25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1277 4.25C8.54191 4.25 8.8777 4.58579 8.8777 5C8.8777 5.3797 8.59555 5.69349 8.22947 5.74315L8.1277 5.75H3C2.88165 5.75 2.78251 5.83223 2.7566 5.94268L2.75 6V7C2.75 7.11835 2.83223 7.21749 2.94268 7.2434L3 7.25H8.53658C8.95079 7.25 9.28658 7.58579 9.28658 8C9.28658 8.3797 9.00443 8.69349 8.63835 8.74315L8.53658 8.75H3C2.08183 8.75 1.32881 8.04289 1.2558 7.14353L1.25 7V6C1.25 5.08183 1.95711 4.32881 2.85647 4.2558L3 4.25H8.1277Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 4.25C21.9183 4.25 22.6713 4.95711 22.7443 5.85647L22.7501 6V7C22.7501 7.91817 22.043 8.67119 21.1436 8.7442L21.0001 8.75H15.4644C15.0501 8.75 14.7144 8.41421 14.7144 8C14.7144 7.6203 14.9965 7.30651 15.3626 7.25685L15.4644 7.25H21.0001C21.1184 7.25 21.2176 7.16777 21.2435 7.05732L21.2501 7V6C21.2501 5.88165 21.1679 5.78251 21.0574 5.7566L21.0001 5.75H15.8726C15.4584 5.75 15.1226 5.41421 15.1226 5C15.1226 4.6203 15.4048 4.30651 15.7708 4.25685L15.8726 4.25H21.0001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.25C22.4142 20.25 22.75 20.5858 22.75 21C22.75 21.3797 22.4678 21.6935 22.1018 21.7432L22 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21C1.25 20.6203 1.53215 20.3065 1.89823 20.2568L2 20.25H22Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C12.3797 13.25 12.6935 13.5322 12.7432 13.8982L12.75 14V21C12.75 21.4142 12.4142 21.75 12 21.75C11.6203 21.75 11.3065 21.4678 11.2568 21.1018L11.25 21V14C11.25 13.5858 11.5858 13.25 12 13.25Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostoTrabalho);
export default __webpack_public_path__ + "static/media/postoTrabalho.bb5bc2385327aeb1e753d6c015a01e41.svg";
export { ForwardRef as ReactComponent };